export default __webpack_public_path__ + "c803f540f9bff56c95a4ccd60b34a764.svg";